import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent implements OnInit {

  categoryFormGroup: FormGroup;
  submitted = false;
  fileToUpload;
  formGroup;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastClientService,
  ) { }


  ngOnInit() {

    this.formGroup = this.fb.group({
      program_id: 1,
      category_name: new FormControl('', [Validators.required]),
      short_name: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      target_threshold_percentage: new FormControl('', [Validators.required]),
      category_image: new FormControl('', [Validators.required]),
    });

  }

  get f() {
    return this.formGroup.controls
  }


  handleFileInput(listOfFiles) {
    let file = listOfFiles[0];
    let fileSize = file.size;

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      this.fileToUpload = reader.result;
    }
  }

  back() {
    this.router.navigateByUrl('/hubAdmin/list-category')
  }


  onSubmitCategory(formData) {
    console.log(formData)
    this.submitted = true;

    console.log(this.formGroup)
    if (this.formGroup.invalid) {
      return;
    }
    formData.category_image = this.fileToUpload;

    this.apiService.post(this.apiConfig.createCatgory, formData)
      .subscribe((res: any) => {
        this.toast.Success('Category added successfully')
        this.router.navigateByUrl('/hubAdmin/list-category')
      }, err => {
        this.toast.Error('Error adding category');
      })

  }

}
